<kendo-textbox-container [formGroup]="form" class="w-100" [floatingLabel]="label">
  <input kendoTextBox type="password" [formControlName]="name">

  <small class="alert-danger" *ngIf="form.get(name).touched && form.get(name).errors && form.get(name).dirty">
    {{form.get(name).hasError('required') ? 'Ce champ est requis' : ''}}
    {{form.get(name).hasError('auth/weak-password') ? 'Le mot de passe doit avoir 6 caractères ou plus' : ''}}
    {{form.get(name).hasError('auth/wrong-password') ? 'Identifiants invalides' : ''}}
  </small>
  <small class="alert-danger" *ngIf="name == 'confirm_password' && form.get(name).touched && form.get(name).dirty && form.errors">
  {{form.hasError('mismatchedPasswords') ? 'Votre mot de passe doit être confirmé correctement' : ''}}
  </small>
</kendo-textbox-container>



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/shared/form/input-password/input-password.component.html